import { render } from "./ModalSelectItemForModiferOptionGroup.vue?vue&type=template&id=712775cc&scoped=true"
import script from "./ModalSelectItemForModiferOptionGroup.vue?vue&type=script&lang=js"
export * from "./ModalSelectItemForModiferOptionGroup.vue?vue&type=script&lang=js"

import "./ModalSelectItemForModiferOptionGroup.vue?vue&type=style&index=0&id=712775cc&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712775cc"]])

export default __exports__